import React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { useDispatch } from 'react-redux';
import { TypesDeleteModal } from './TypeDelete';
import styles from './DeleteModalStyle.module.scss';
import { DeleteModalIcon } from '../../../../media/images/DeleteModalIcon';
import { deleteLevelStart } from '../../../../redux/masters/masterSlice';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 539,
  height: 'auto',
  bgcolor: 'background.paper',
  borderRadius: '6px',
  boxShadow: 24,
  p: 5,
  '@media (max-width: 768px)': {
    width: '90%',
  },
};
export default function DeleteLevelConfirmationModal({ show, setOpenFrom, selectedId }: TypesDeleteModal): JSX.Element {
  const dispatch = useDispatch();
  const deleteLevel = () => {
    const payload = selectedId;
    dispatch(deleteLevelStart(payload));
    setOpenFrom();
  };

  return (
    <Modal
      open={show}
      onClose={setOpenFrom}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className={styles.deleteIcon}>
          <DeleteModalIcon />
        </div>
        <div className={styles.modalModalHeading}>
          Are you sure?
        </div>
        <div className={styles.modalModalDescription}>
          Are you sure you want to delete this level info permanently? This will be removed in all associated records and cannot be undone.
        </div>

        <div className={styles.divButtons}>
          <button
            type="button"
            className={`btn ${styles.deleteBtn}`}
            onClick={() => {
              deleteLevel();
            }}
          >
            Yes, Delete it!
          </button>
          <button type="button" className={`btn ${styles.cancelBtn}`} onClick={setOpenFrom}>Cancel</button>
        </div>
      </Box>
    </Modal>
  );
}
